export  const openModel=(id)=> {
    if(document.getElementById(id)){
        document.getElementById(id).style.display='block';
        document.getElementById(id).classList.add("show");
        let element=document.createElement("div");
        element.classList.add("modal-backdrop","show");
        document.body.appendChild(element);
    }
}